export const EVERBRIDGE_FLOW_DESIGNER = 'everbridge flow designer';

export const isEverbridgeFlowDesignerProduct = productName =>
  productName.toLowerCase().includes(EVERBRIDGE_FLOW_DESIGNER);
